import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const Footer = () => {
  const services = [
    { name: "Kitchen Tiling", path: "/services" },
    { name: "Bathroom Tiling", path: "/services" },
    { name: "Floor Tiling", path: "/floor-tiling-quote" },
    { name: "Bathroom Renovations", path: "/bathroom-refit-quote" },
  ];

  const areas = [
    "Manchester",
    "Salford",
    "Stockport",
    "Trafford",
    "Bolton",
    "Bury",
    "Oldham",
    "Rochdale",
    "Tameside",
    "Wigan",
  ];

  const quickLinks = [
    { name: "About Us", path: "/about" },
    { name: "Our Projects", path: "/projects" },
    { name: "Reviews", path: "/reviews" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <footer className="footer pt-16 pb-8" data-testid="footer">
      <div className="container-custom">
        {/* CTA Section */}
        <div className="bg-primary rounded-2xl p-8 md:p-12 mb-16 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 font-montserrat">
            Ready to Transform Your Space?
          </h2>
          <p className="text-white/80 mb-6 max-w-2xl mx-auto">
            Get your free estimate in under 60 seconds. Professional installations, reliable quotes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/estimate">
              <Button 
                className="bg-white text-primary hover:bg-gray-100 text-lg px-8 py-6"
                data-testid="footer-cta"
              >
                Start My Estimate
              </Button>
            </Link>
            <Link to="/book">
              <Button 
                variant="outline"
                className="border-2 border-white text-white hover:bg-white/10 text-lg px-8 py-6"
                data-testid="footer-book-quote"
              >
                <Calendar className="w-5 h-5 mr-2" />
                Book a Quote
              </Button>
            </Link>
          </div>
        </div>

        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">DC</span>
              </div>
              <span className="font-montserrat font-bold text-xl text-white">
                DC Tiling & Bathrooms
              </span>
            </Link>
            <p className="text-gray-400 mb-6">
              Professional tiling and bathroom renovation services across Greater Manchester and surrounding areas.
            </p>
            <div className="space-y-3">
              <a href="tel:+447547393455" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <Phone className="w-5 h-5" />
                <span>07547 393 455</span>
              </a>
              <a href="mailto:info@dctiling.co.uk" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
                <span>info@dctiling.co.uk</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <Clock className="w-5 h-5" />
                <span>Mon-Sat: 8am - 6pm</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-6">Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link to={service.path} className="footer-link">
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-6">Service Areas</h3>
            <ul className="space-y-3">
              {areas.map((area) => (
                <li key={area} className="flex items-center gap-2 text-gray-400">
                  <MapPin className="w-4 h-4" />
                  <span>{area}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} DC Tiling & Bathrooms. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
        
        {/* Mobile spacing for sticky footer bar */}
        <div className="h-16 md:hidden" />
      </div>
    </footer>
  );
};

export default Footer;
